import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';

import { AuthUserSettingsService } from '@ib-core/services/auth-user-settings.service';
import { DATA_TYPE, DATE_VIEW_TYPE } from '@ib-shared/types/data.type';
import * as dayjs from 'dayjs';
import { combineLatest, map, Observable } from 'rxjs';

import { DateTimeFormatService } from './date-time-format.service';

@Injectable({ providedIn: 'root' })
export class DataViewService {
  constructor(
    private settings: AuthUserSettingsService,
    private dateTimeFormatS: DateTimeFormatService,
    private decimalP: DecimalPipe,
  ) {}

  public getObsByType(p: {
    dataType: DATA_TYPE;
    dateView?: DATE_VIEW_TYPE;
    val$: Observable<string | number>;
  }): Observable<string | number> {
    switch (p.dataType) {
      case 'date':
        return combineLatest([
          p.val$,
          this.dateTimeFormatS.datesView$.asObservable(),
        ]).pipe(
          // todo ? user timezone
          // todo ? user selected time format
          map(([val, format]) => {
            return val ? dayjs(val).format(format) : '-';
          }),
        );
      case 'number':
        return combineLatest([
          p.val$,
          this.settings.numbersView$.asObservable(),
        ]).pipe(
          map(([val, format]) => {
            return val ? this.decimalP.transform(val, format) : '-';
          }),
        );
      case 'money':
        return combineLatest([
          p.val$,
          this.settings.numbersView$.asObservable(),
        ]).pipe(
          map(([val, format]) => {
            return val ? this.decimalP.transform(val, format) : '-';
          }),
        );
      case 'percents':
        return combineLatest([
          p.val$,
          this.settings.percentsOneNumBeforeDotView$.asObservable(),
          this.settings.percentsTwoNumBeforeDotView$.asObservable(),
        ]).pipe(
          map(([val, formatOne, formatTwo]) => {
            const v = Math.floor(val as number).toString();
            return val
              ? this.decimalP.transform(
                  val,
                  v.length === 1 ? formatOne : formatTwo,
                )
              : '-';
          }),
        );
      default:
        return p.val$;
    }
  }
}
